module.exports = __webpack_public_path__ + "sk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sk.svg
// module id = 1061
// module chunks = 0